import { Fragment } from 'react';

// material-ui
import {
  Divider,
  IconButton,
  ListItemAvatar,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography
} from '@mui/material';
import UserAvatar from './UserAvatar';
import { User } from '../../graphql/types';
import { CaretDownOutlined } from '@ant-design/icons';
import { getUserProfileFullName } from '../../utils/users';

// project imports

export interface UserListOptionProps {
  user: User;
  type: string;
  onClick?: any;
  showEditAction?: boolean | undefined;
}

function UserListButtonOption({ showEditAction, user, type, onClick }: UserListOptionProps) {
  return (
    <Fragment>
      <ListItemButton onClick={onClick}>
        <ListItemAvatar sx={{ minWidth: 42 }}>
          <UserAvatar user={user} />
        </ListItemAvatar>
        <ListItemText
          primary={
            <Stack component="span" direction="column" alignItems="left" justifyContent="space-between" spacing={0.2}>
              <Typography component="span" color="textSecondary" variant="caption">
                {type}
              </Typography>
              <Typography variant="body2" color="inherit" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {getUserProfileFullName(user)}
              </Typography>
            </Stack>
          }
        />
        {!!showEditAction && (
          <ListItemSecondaryAction>
            <IconButton disabled={true} edge="end" color="secondary" aria-label="Click to edit">
              <CaretDownOutlined />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItemButton>
      <Divider />
    </Fragment>
  );
}

export default UserListButtonOption;
